import React, { useCallback, useEffect, useRef, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../../Components/CreateVoucherAndCouponsInputs/CreateVoucherAndCouponsInputs.css";
import Navigation from "../Navigation/Navigation";

import { format } from "date-fns";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.css";
import "froala-editor/js/plugins.pkgd.min.js";
import {
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cropper from "react-easy-crop";
import FroalaEditor from "react-froala-wysiwyg";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { toast } from "react-toastify";
import Datepickericon from "../../assets/date-picker.svg";
import defaultupload from "../../assets/default-upload.svg";
import iicon from "../../assets/i.svg";
import SuccessImage from "../../assets/t-successfull.png";
import "../../Components/CreateVoucherAndCouponsInputs/CreateVoucherAndCouponsInputs.css";
import Modals from "../../Components/CreateVoucherCouponModal/CreateVoucherCouponModal";
import ProductModal from "../../Components/CreateVoucherCouponModal/ProductModal";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../Components/Loader/Loader";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { CreateVoucherApi } from "../../Utils/Api/CreateVoucherApi";
import { ManageVouchersApi } from "../../Utils/Api/ManageVouchers";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { getUser, userId } from "../../Utils/LocalStorage";
import getCroppedImg from "./cropImage";
import { FroalaTextEditor } from "../../Components/FroalaEditor/FroalaTextEditor";
import { stripHTML } from "../../Components/FroalaEditor/StripHtml";
import { constant } from "../../Utils/Constant";
import { ErrorMessage } from "../../Utils/ErrorMsg/ErrorMsg";
import defaultupload_fb from "../../assets/default-fb.png";
import { resizeImage } from "../../Utils/ResizeUploadImg";

const EditVoucher = () => {
  const max_character_count =1000;
  const parameter = useParams();
  const id = parseInt(parameter.id);
  const flag = parameter.flag;
  const flagValue = flag ? true : false;
  const [inputtnc, setInputtnc] = useState();
  const [addtnc, setAddtnc] = useState([]);
  const [existingTnc, setExistingTnc] = useState([]);
  const [defaultTnc, setDefaultTnc] = useState([]);
  const [checkedItems, setCheckedItems] = useState();
  const [dat, setDat] = useState([]);
  const [data, setData] = useState([]);
  const [isbaseImage, setIsBaseImage] = useState(false);
  const [dataApihandler, setDataApihandler] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [description, setDescription] = useState("");
  const [errorLabelDesc, setErrorLabelDesc] = useState("");
  const [errorLabeltnc, setErrorLabeltnc] = useState("");
  const [errorLabelname, setErrorLabelname] = useState("");
  const [errorLabelprice, setErrorLabelprice] = useState("");
  const [errorLabellimit, setErrorLabellimit] = useState("");
  const [errorLabelvalue, setErrorLabelvalue] = useState("");
  const [errorLabelstart, setErrorLabelstart] = useState("");
  const [errorLabelend, setErrorLabelend] = useState("");
  const [errorLabelAvailableDate, setErrorLabelAvailableDate] = useState("");
  const [publishedFlag, setPublishedflag] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(flagValue);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableDate, setAvailableDate] = useState(null);
  const [plainText, setPlainText] = useState("");

  const [show, setShow] = useState(false);
  const [productModalShow, setProductModalShow] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [imageType, setImageType] = useState("");

  // upload-banner-img
  const [prevImg, setPrevimg] = useState("");
  const [cropImgBanner, setcropImgBanner] = useState("");
  const [bannerImageFlag, setbannerImageFlag] = useState(false);
  const [ImagePath, setImagePath] = useState("");

  const [showFb, setShowFb] = useState(false);
  const [prevImgFb, setPrevimgFb] = useState("");
  const [cropImgBannerFb, setcropImgBannerFb] = useState("");
  const [bannerImageFlagFb, setbannerImageFlagFb] = useState(false);
  const [ImagePathFb, setImagePathFb] = useState("");
  const [isbaseImageFb, setIsBaseImageFb] = useState(false);

  const allTnc = [...new Set([...existingTnc, ...defaultTnc])];

  const uid = parseInt(userId());

  const handleModelChange = (model) => {
    setDescription(model);
  };

  const handleStart = (e) => {
    setStartDate(e);
  };

  const handleEnd = (e) => {
    const EndDate = e;
    setEndDate(EndDate);
  };

  const handleAvailableDate = (e) => {
    setAvailableDate(e);
  };

  const handleChangetnc = (event) => {
    setInputtnc(event.target.value);
  };

  const handleCheck = (item) => {
    if (checkedItems.includes(item)) {
      setCheckedItems(
        checkedItems.filter((checkedItem) => checkedItem !== item)
      );
    } else {
      setCheckedItems([...checkedItems, item]);
    }
  };

  const handleAdd = (event) => {
    event.preventDefault();
    let temp = inputtnc;
    if (inputtnc === undefined) {
    } else {
      setAddtnc((addtnc) => [...addtnc, temp]);
      setErrorLabeltnc("");
    }
    setInputtnc("");
  };

  const handleTncApi = async () => {
    const data = {
      api_method: "get",
    };
    const tncList = await CreateVoucherApi(data, () => {
      navigate("/");
    });
    if (tncList.status === 429) {
      setLoading(true);
      toast.error(tncList.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }

    let unique1 = tncList.tnc.filter((o) => existingTnc.indexOf(o) === -1);
    let list = unique1.concat(addtnc);
    setDefaultTnc(list);
  };

  const numbersOnly = (str, flag) => {
    const regexDeci = /^(0|[1-9]\d*)(\.\d+)?$/;
    const regexNum = /^[0-9]+$/;
    if (flag === "actualprice") {
      return regexDeci.test(str);
    } else if (flag === "discountprice") {
      return regexDeci.test(str);
    } else if (flag === "limit") {
      return regexNum.test(str);
    }
  };
  const Bu_data = getUser();

  const handleSubmit = (e, type) => {
    e.preventDefault();

    let flag = false;
    const plainText = stripHTML(description);
    const currentCharCount = plainText.length;
    const hasInvalidTags = /<img|<figure/i.test(description);
    if (!description) {
      setErrorLabelDesc("Please provide some description!");
      flag = true;
    } else if (
      hasInvalidTags &&
      currentCharCount > max_character_count
    ) {
      setErrorLabelDesc(`Character limit exceeded! You can only enter up to ${max_character_count} characters, and images are not allowed.`);
      flag = true;
    } else if (hasInvalidTags) {
      setErrorLabelDesc(ErrorMessage.ImageError);
      flag = true;
    } else if (currentCharCount > max_character_count) {
      setErrorLabelDesc(`Character limit exceeded! You can only enter up to ${max_character_count} characters.`);
      flag = true;
    } else {
      setErrorLabelDesc("");
      flag = false;
    }

    if (dat.voucher_name == "") {
      setErrorLabelname("Please enter voucher name!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelname("");
    }

    if (dat.total.length === 0) {
      setErrorLabellimit("Please enter voucher limit!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (dat.total == 0) {
      setErrorLabellimit("Voucher limit cannot be zero!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (numbersOnly(dat.total, "limit") === false) {
      setErrorLabellimit("Please enter valid limit!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabellimit("");
    }

    if (dat.voucher_price === "") {
      setErrorLabelprice("Please enter the discounted price!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (parseInt(dat.voucher_price) === 0) {
      setErrorLabelprice("Voucher discounted price cannot be zero!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (numbersOnly(dat.voucher_price, "actualprice") === false) {
      setErrorLabelprice("Please enter valid discounted price!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (parseFloat(dat.voucher_value) < parseFloat(dat.voucher_price)) {
      setErrorLabelprice(
        "Discounted value must be lesser than the Retail Value!"
      );
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelprice("");
    }

    if (dat.voucher_value == "") {
      setErrorLabelvalue("Please enter the field!");
      flag = true;
    } else {
      setErrorLabelvalue("");
    }

    if (dat.voucher_value == "") {
      setErrorLabelvalue("Please enter the retail price!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (parseInt(dat.voucher_value) === 0) {
      setErrorLabelvalue("Voucher retail value cannot be zero!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (numbersOnly(dat.voucher_value, "discountprice") === false) {
      setErrorLabelvalue("Please enter valid retail price!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelvalue("");
    }

    if (!startDate) {
      setErrorLabelstart("Please enter start date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelstart("");
    }

    if (!endDate) {
      setErrorLabelend("Please enter expiration date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelend("");
    }

    if (!availableDate) {
      setErrorLabelAvailableDate("Please enter available until date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelAvailableDate("");
    }

    if (checkedItems.length === 0) {
      setErrorLabeltnc("Please select at least one terms & condition!");
      flag = true;
    } else {
      setErrorLabeltnc("");
    }

    var imgPath;
    if (!isbaseImage) {
      imgPath = cropImgBanner.split("/").slice(3).join("/");
    }

    var imgPathFb;
    if (!isbaseImageFb) {
      imgPathFb = cropImgBannerFb.split("/").slice(3).join("/");
    }

    if (flag === false) {
      const dataApi = {
        api_method: "post",
        voucher_name: dat.voucher_name,
        business_id: parseInt(uid),
        category_id: Bu_data.category_id,
        voucher_limit: parseInt(dat.total),
        voucher_value: parseInt(dat.voucher_value),
        voucher_price: parseInt(dat.voucher_price),
        expiry_start_date: format(startDate, "yyyy-MM-dd"),
        expiry_end_date: format(endDate, "yyyy-MM-dd"),
        voucher_avail_until_date: format(availableDate, "yyyy-MM-dd"),
        description: description,
        city_id: Bu_data.city_id,
        is_image_changed: isbaseImage,
        image_path: {
          data: isbaseImage ? cropImgBanner : imgPath,
          file_type: "png",
        },

        is_social_image: isbaseImageFb,
        voucher_social_image_path: {
          data: isbaseImageFb ? cropImgBannerFb : imgPathFb,
          file_type: "png",
        },
        tnc: checkedItems,
      };

      if (type === "preview") {
        setProductModalShow(true);
      } else if (type === "save") {
        setDataApihandler(dataApi);
        setModalShow(true);
      }
    }
  };

  const navigate = useNavigate();

  const handleCreate = async () => {
    setLoading(true);
    const res = await CreateVoucherApi(dataApihandler, () => {
      navigate("/");
    });
    if (res === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (res.success === true) {
        toast.success(res.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("/my-account/manage-vouchers");
        setPublishedflag(false);
        setEdit(flagValue);
        setErrorLabelDesc("");
        setErrorLabelend("");
        setErrorLabellimit("");
        setErrorLabelname("");
        setErrorLabelprice("");
        setErrorLabelstart("");
        setErrorLabeltnc("");
        setErrorLabelvalue("");
        setErrorLabelAvailableDate("");
        setLoading(false);
      } else {
        toast.error(res.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  const handleApi = async () => {
    const d = {
      business_id: uid,
      voucher_id: id,
      limit: 8,
      offset: 0,
    };
    setLoading(true);
    const response = await ManageVouchersApi(d, () => {
      navigate("/");
    });
    if (response === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (response.status === 429) {
        toast.error(response.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(true);
      } else if (response.success === true) {
        setData(response.data[0]);
        setIsActive(response.data[0].is_active);
        setcropImgBanner(response.data[0].voucher_image);
        setcropImgBannerFb(response.data[0].voucher_social_image);
        //  banner-img
        const CoverImageSplit = response.data[0].voucher_image;
        const CoverImagePath = CoverImageSplit.split("/");
        const getUnchangedPath =
          CoverImagePath[3] + "/" + CoverImagePath[4] + "/" + CoverImagePath[5];
        setImagePath(getUnchangedPath);
        setDat({
          voucher_name: "",
          // voucher_name: response.data[0].voucher_name,
          total: "",
          // total: response.data[0].total,
          voucher_value: "",
          // voucher_value: response.data[0].voucher_value,
          voucher_price: "",
          // voucher_price: response.data[0].voucher_price,
          voucher_image: response.data[0].voucher_image,
        });
        let voucherTnc = response.data[0].voucher_tnc;

        setDescription(response.data[0].voucher_description);

        if (flagValue) {
          setStartDate(null);
          setEndDate(null);
          setAvailableDate(null);
          setPublishedflag(false);
          setExistingTnc(voucherTnc.slice(1, voucherTnc.length));
        } else {
          setPublishedflag(response.data[0].published);
          let actualDate = new Date(response.data[0].start_date);
          setStartDate(actualDate);
          let actualDateend = new Date(response.data[0].end_date);
          setEndDate(actualDateend);
          let actualAvailableDate = new Date(
            response.data[0].voucher_avail_until_date
          );
          setAvailableDate(actualAvailableDate);
          setExistingTnc(voucherTnc);
        }

        setPlainText(
          response.data[0].voucher_description ? (
            response.data[0].voucher_description
          ) : (
            <></>
          )
        );
        setLoading(false);
      } else {
        toast.error(response.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  const handleChange = (e, flag) => {
    console.log("click");
    if (flag === "voucher_value") {
      setDat((ps) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const truncatedValue = sanitizedValue.slice(0, 10);
        const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
        let finalNumber;
        if (validNumber.includes(".")) {
          const [integerPart, decimalPart] = validNumber.split(".");
          const truncatedDecimalPart = decimalPart.slice(0, 2);
          finalNumber = `${integerPart}.${truncatedDecimalPart}`;
        } else {
          finalNumber = validNumber;
        }

        return {
          ...ps,
          [e.target.name]: finalNumber,
        };
      });
    } else if (flag === "voucher_price") {
      setDat((ps) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");
        const truncatedValue = sanitizedValue.slice(0, 10);
        const validNumber = truncatedValue.replace(/(\..*?)\..*/g, "$1");
        let finalNumber;
        if (validNumber.includes(".")) {
          const [integerPart, decimalPart] = validNumber.split(".");
          const truncatedDecimalPart = decimalPart.slice(0, 2);
          finalNumber = `${integerPart}.${truncatedDecimalPart}`;
        } else {
          finalNumber = validNumber;
        }
        return {
          ...ps,
          [e.target.name]: finalNumber,
        };
      });
    } else if (flag === "total") {
      const regex = /^[0-9]*$/;
      const inputValue = e.target.value;

      if (regex.test(inputValue)) {
        setDat((ps) => ({
          ...ps,
          [e.target.name]: inputValue,
        }));
      }
    } else if (flag === "voucher_name") {
      setDat((ps) => {
        return { ...ps, [e.target.name]: e.target.value };
      });
    }
  };

  useEffect(() => {
    handleApi();
    handleTncApi();
  }, [edit]);

  useEffect(() => {
    handleTncApi();
  }, [addtnc]);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      setIsBaseImage(true);
      setcropImgBanner(croppedImage);

      let typeImg = croppedImage.split("/");
      let imageTypeSplit = typeImg[1].split(";");

      setImageType(imageTypeSplit[0]);
      setShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImageFb = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImgFb,
        croppedAreaPixels,
        rotation
      );
      setIsBaseImageFb(true);
      setcropImgBannerFb(croppedImage);

      let typeImg = croppedImage.split("/");
      let imageTypeSplit = typeImg[1].split(";");

      setImageType(imageTypeSplit[0]);
      setShowFb(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  // upload-banner-img
  const inputRef = useRef();
  const triggerFileSelectPopup = () => inputRef.current.click();

  // upload-fb-img
  const inputRefFb = useRef();
  const triggerFileSelectPopupFb = () => inputRefFb.current.click();

  const handleSetCropperImg = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new window.Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      (async () => {
        const resizedImage = await resizeImage(
          img,
          constant.max_img_width,
          constant.max_img_height
        );
        setShow(true);
        setPrevimg(resizedImage);
      })();
    };
  };

  const handleSetCropperImgFb = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new window.Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      (async () => {
        const resizedImage = await resizeImage(
          img,
          constant.max_img_width,
          constant.max_img_height
        );
        setShowFb(true);
        setPrevimgFb(resizedImage);
      })();
    };
  };

  useEffect(() => {
    setCheckedItems(existingTnc);
  }, [existingTnc]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-account/manage-vouchers"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">
            {edit === false ? "View Voucher" : "Clone Voucher"}

            {/* <div className="text-right two-btns">
              {isActive === false ||
                (edit === false && (
                  <Button
                    className="green-btn mr-2 editBtn"
                    onClick={() => setEdit(true)}
                  >
                    <MdEdit /> Edit
                  </Button>
                ))}
            </div> */}
          </p>
          <div className="acc-dashboard mt-4">
            <div className="Create-voucher_top-section">
              <Modal
                show={show}
                onHide={() => setShow(false)}
                style={{ marginTop: 0 }}
              >
                <Modal.Header></Modal.Header>
                <Modal.Body
                  style={{ width: "100%", height: 350, body: "none" }}
                >
                  <div>
                    <Cropper
                      image={prevImg}
                      crop={crop}
                      rotation={rotation}
                      zoom={zoom}
                      aspect={4 / 4}
                      cropShape="square"
                      showGrid={false}
                      onCropChange={setCrop}
                      onRotationChange={setRotation}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className="cropperImage">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShow(false);
                      setbannerImageFlag(false);
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      showCroppedImage();
                      setbannerImageFlag(true);
                    }}
                  >
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* fb-modal */}
              <Modal
                show={showFb}
                onHide={() => setShowFb(false)}
                style={{ marginTop: 0 }}
              >
                <Modal.Header></Modal.Header>
                <Modal.Body
                  style={{ width: "100%", height: 350, body: "none" }}
                >
                  <div>
                    <Cropper
                      image={prevImgFb}
                      crop={crop}
                      rotation={rotation}
                      zoom={zoom}
                      aspect={1.91 / 1}
                      showGrid={false}
                      onCropChange={setCrop}
                      onRotationChange={setRotation}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className="cropperImage">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowFb(false);
                      setbannerImageFlagFb(false);
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      showCroppedImageFb();
                      setbannerImageFlagFb(true);
                    }}
                  >
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>

              <div className="input_fileds">
                <Form className="formmain mx-2 mt-2 signin-row profile-form pb-0 Create-Vouch">
                  <Row>
                    <Col md="12" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Voucher Name <span className="star-required">*</span>
                        </Form.Label>
                        <InputGroup className="edit-border">
                          <Form.Control
                            style={{ width: "100%" }}
                            type="text"
                            placeholder="Voucher Name"
                            className="custom-formcontrol"
                            maxLength={200}
                            name="voucher_name"
                            onChange={(e) => handleChange(e, "voucher_name")}
                            disabled={
                              publishedFlag === false && edit === true
                                ? false
                                : true
                            }
                            value={
                              edit === true
                                ? dat.voucher_name
                                : data.voucher_name
                            }
                          />
                        </InputGroup>
                        <ErrorLabel ErrorDisplay={errorLabelname} />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-flex gap-30 mb-4 img_sec_product">
                    <div className="col-4 px-0 mb-2 product-upload-section">
                      <div className="hiddenFileInputContainter">
                        <p className="uploadtextmain">
                          Upload Voucher Image &nbsp;
                          <span className="star-required">*</span>
                          <br />
                          <span className="info_text">
                            (Recommended size 1000px x 1000px)
                          </span>
                        </p>

                        {/* upload sec */}
                        <div
                          className="upload_main_banner"
                          onClick={
                            publishedFlag === false && edit === true
                              ? triggerFileSelectPopup
                              : ""
                          }
                        >
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputRef}
                            style={{ display: "none" }}
                            onChange={handleSetCropperImg}
                            onClick={(e) => (e.target.value = null)}
                          />
                          <div>
                            {cropImgBanner == "" ? (
                              <>
                                <div className="upload_banner_empty">
                                  <img
                                    loading="lazy"
                                    src={defaultupload}
                                    height="300"
                                    width="300"
                                    alt="upload"
                                  />
                                </div>
                              </>
                            ) : (
                              <img
                                loading="lazy"
                                src={cropImgBanner}
                                className="BannerImgStore"
                                height={300}
                                width={300}
                                style={{
                                  cursor:
                                    publishedFlag === false && edit === true
                                      ? "pointer"
                                      : "not-allowed",
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* fb */}
                    <div className="col-8 px-0">
                      <div className="hiddenFileInputContainter">
                        <p className="uploadtextmain">
                          Upload Social Share Image &nbsp;
                          <span style={{ fontSize: 13, fontStyle: "italic" }}>
                            &#40;Optional&#41;
                          </span>
                          &nbsp;&nbsp;
                          <span className="info_text">
                            (Recommended size 1200px x 630px)
                          </span>
                          <br />
                          <div style={{ paddingRight: 10 }}>
                            <p className="span-italic-grey1">
                              &#40;This image is ideal for social share, if you
                              are unable to provide this size we will use the
                              square image modified to fit the standard image
                              recommendation.&#41;
                            </p>
                          </div>
                        </p>

                        {/* upload sec */}
                        <div
                          className="upload_main_banner"
                          onClick={
                            publishedFlag === false && edit === true
                              ? triggerFileSelectPopupFb
                              : ""
                          }
                        >
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputRefFb}
                            style={{ display: "none" }}
                            onChange={handleSetCropperImgFb}
                            onClick={(e) => (e.target.value = null)}
                          />
                          <div>
                            {cropImgBannerFb == "" ? (
                              <>
                                <div className="upload_banner_empty_fb">
                                  <img
                                    loading="lazy"
                                    src={defaultupload_fb}
                                    alt="upload"
                                  />
                                </div>
                              </>
                            ) : (
                              <img
                                loading="lazy"
                                src={cropImgBannerFb}
                                className="BannerImgStore"
                                style={{
                                  cursor:
                                    publishedFlag === false && edit === true
                                      ? "pointer"
                                      : "not-allowed",
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Row className="VoucherAmountDollar mt-3 pt-3">
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <div>
                            <p className="VoucherP VLimit">Voucher</p>
                            <p>
                              Limit
                              <span className="star-required">
                                *
                                {["top"].map((placement) => (
                                  <OverlayTrigger
                                    // trigger={"click"}
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${placement}`}
                                        style={{ width: "50%" }}
                                      >
                                        This field indicates quantity of the
                                        voucher. (ex: if you are entering 10 as
                                        voucher limit it will allow only 10
                                        vouchers to be created)
                                      </Tooltip>
                                    }
                                  >
                                    <Image
                                      loading="lazy"
                                      src={iicon}
                                      className="mb-1"
                                      width="15px"
                                    ></Image>
                                  </OverlayTrigger>
                                ))}
                              </span>
                            </p>
                          </div>

                          {flagValue && (
                            <p className="info-text-space">
                              &#40;One Voucher Per Transaction&#41;
                            </p>
                          )}
                        </Form.Label>
                        <div className="editInputDiv">
                          <InputGroup className="edit-border special">
                            <Form.Control
                              // style={{ width: "200px" }}
                              type="text"
                              placeholder="Voucher Limit"
                              className="custom-formcontrol"
                              maxLength={3}
                              name="total"
                              onChange={(e) => handleChange(e, "total")}
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : publishedFlag === true && edit === true
                                  ? false
                                  : true
                              }
                              value={edit === true ? dat.total : data.total}
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabellimit} />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <div>
                            <p className="VoucherP VValue">Voucher Retail </p>
                            <p>
                              Value
                              <span className="star-required">
                                *
                                {["top"].map((placement) => (
                                  <OverlayTrigger
                                    // trigger={"click"}
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${placement}`}
                                        style={{ width: "50%" }}
                                      >
                                        This is the actual price of the voucher.
                                      </Tooltip>
                                    }
                                  >
                                    <Image
                                      loading="lazy"
                                      src={iicon}
                                      className="mb-1"
                                      width="15px"
                                    ></Image>
                                  </OverlayTrigger>
                                ))}
                              </span>
                            </p>
                          </div>
                          {flagValue && (
                            <p className="info-text-space">
                              &#40;Value cannot be zero&#41;
                            </p>
                          )}
                        </Form.Label>
                        <div className="editInputDiv">
                          <InputGroup className="edit-border special">
                            <Form.Control
                              // style={{ width: "200px" }}
                              type="text"
                              placeholder="Voucher Value"
                              className="custom-formcontrol"
                              maxLength={10}
                              name="voucher_value"
                              onChange={(e) => handleChange(e, "voucher_value")}
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : true
                              }
                              value={
                                edit === true
                                  ? dat.voucher_value
                                  : data.voucher_value
                              }
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelvalue} />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <div>
                            <p className="VoucherP VDiscount">
                              Voucher Discounted{" "}
                            </p>
                            <p>
                              Price
                              <span className="star-required">*</span>
                            </p>
                          </div>
                          {flagValue && (
                            <p className="info-text-space">
                              &#40;Value cannot be zero&#41;
                            </p>
                          )}
                        </Form.Label>
                        <div className="editInputDiv">
                          <InputGroup
                            className="edit-border special"
                            style={{ display: "flex" }}
                          >
                            <Form.Control
                              type="text"
                              placeholder="Voucher Price"
                              className="custom-formcontrol"
                              maxLength={10}
                              name="voucher_price"
                              onChange={(e) => handleChange(e, "voucher_price")}
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : true
                              }
                              value={
                                edit === true
                                  ? dat.voucher_price
                                  : data.voucher_price
                              }
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelprice} />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="VoucherAmountDollar">
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <p>
                            Voucher Publish Start Date
                            <span className="star-required">*</span>
                          </p>
                        </Form.Label>
                        <div>
                          <InputGroup
                            className="edit-border"
                            disabled={edit === true ? false : true}
                          >
                            <DatePicker
                              selected={startDate}
                              className="custom-formcontrol"
                              onChange={handleStart}
                              placeholderText="Publish Start Date"
                              minDate={new Date()}
                              maxDate={
                                availableDate !== null
                                  ? availableDate
                                  : endDate !== null
                                  ? endDate
                                  : ""
                              }
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : true
                              }
                            />
                            <Image
                              loading="lazy"
                              src={Datepickericon}
                              className="date-picker-icon"
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelstart} />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <p>
                            Voucher Available Until Date
                            <span className="star-required">*</span>
                          </p>
                        </Form.Label>
                        <div>
                          <InputGroup className="edit-border">
                            <DatePicker
                              selected={availableDate}
                              className="custom-formcontrol"
                              onChange={handleAvailableDate}
                              minDate={
                                startDate !== null ? startDate : new Date()
                              }
                              maxDate={endDate !== null ? endDate : null}
                              placeholderText="Available Until Date"
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : publishedFlag === true && edit === true
                                  ? false
                                  : true
                              }
                            />
                            <Image
                              loading="lazy"
                              src={Datepickericon}
                              className="date-picker-icon"
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelAvailableDate} />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <p>
                            Voucher Expiration Date
                            <span className="star-required">*</span>
                          </p>
                        </Form.Label>
                        <div>
                          <InputGroup className="edit-border">
                            <DatePicker
                              selected={endDate}
                              className="custom-formcontrol"
                              placeholderText="Expiration Date"
                              onChange={handleEnd}
                              minDate={
                                availableDate !== null &&
                                availableDate > startDate
                                  ? availableDate
                                  : startDate !== null
                                  ? startDate
                                  : new Date()
                              }
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : publishedFlag === true && edit === true
                                  ? false
                                  : true
                              }
                            />
                            <Image
                              loading="lazy"
                              src={Datepickericon}
                              className="date-picker-icon"
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelend} />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>

            <Row
              className={`mx-2 desc_terms_condition ${
                flagValue === true ? "true" : ""
              }`}
            >
              <Col md="12" className="px-2">
                <Form.Group className="mb-4 mt-4" controlId="formBasicEmail">
                  {(publishedFlag === true && edit === true) ||
                  edit === false ? (
                    <>
                      <Form.Label className="form-label-custom info-sec">
                        Voucher Description
                        <span className="star-required">*</span>{" "}
                      </Form.Label>
                      <FroalaEditorView model={plainText} />
                    </>
                  ) : publishedFlag === false && edit === true ? (
                    <>
                      <Form.Label className="form-label-custom info-sec">
                        Voucher Description{" "}
                        <span className="star-required">*</span>{" "}
                        <p className="info-text-space-f13">
                          &#40;To start from a new line, please press Shift +
                          Enter.&#41;
                        </p>
                      </Form.Label>
                      <FroalaTextEditor
                        description={description}
                        setDescription={setDescription}
                        max_character_count={max_character_count}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  <ErrorLabel ErrorDisplay={errorLabelDesc} />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mx-2 desc_terms_condition">
              <Col md="12" className="px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Terms & Conditions <span className="star-required">*</span>
                    {edit === true && (
                      <span className="span-italic">
                        You can select terms & conditions listed below or you
                        can add more.
                      </span>
                    )}
                  </Form.Label>
                  <InputGroup className="edit-border">
                    {(publishedFlag === true && edit === true) ||
                    edit === false ? (
                      <Form.Group
                        className="mb-3 ack term-sec"
                        controlId="formBasicCheckbox"
                      >
                        {existingTnc
                          ? existingTnc.map((item) => {
                              return (
                                <ul>
                                  <li>{item}</li>
                                </ul>
                              );
                            })
                          : " "}
                        <ErrorLabel ErrorDisplay={errorLabeltnc} />
                      </Form.Group>
                    ) : (
                      publishedFlag === false &&
                      edit === true && (
                        <InputGroup className="edit-border">
                          <Form.Group
                            className="mb-3 ack term-sec tnc-wrapper"
                            controlId="formBasicCheckbox"
                          >
                            {allTnc &&
                              allTnc.length > 0 &&
                              allTnc.map((item, i) => {
                                return (
                                  <label
                                    for={item}
                                    value={item}
                                    className="form-check-label"
                                    style={{ display: "flex", gap: 10 }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={item}
                                      className="form-check-input form-check ack"
                                      style={{ border: "1px solid #e66100" }}
                                      checked={checkedItems.includes(item)}
                                      onChange={() => handleCheck(item)}
                                    />
                                    {item}
                                  </label>
                                );
                              })}
                            <InputGroup className="search-bar add-bar tcAdd">
                              <Form.Control
                                placeholder="Add More"
                                onChange={handleChangetnc}
                                value={inputtnc}
                                className="addmor"
                                maxLength={200}
                              />
                              <Button
                                variant="outline-secondary"
                                onClick={handleAdd}
                              >
                                + Add
                              </Button>
                            </InputGroup>
                            <ErrorLabel ErrorDisplay={errorLabeltnc} />
                          </Form.Group>
                        </InputGroup>
                      )
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {edit === true && (
                <>
                  <div className="text-center small-btns d-flex my-4">
                    <button
                      className="green-btn"
                      onClick={(e) => handleSubmit(e, "preview")}
                    >
                      Preview
                    </button>
                  </div>
                  <div className="text-center small-btns d-flex mb-4">
                    <Link
                      onClick={() => {
                        setEdit(!edit);
                        setErrorLabelDesc("");
                        setErrorLabelend("");
                        setErrorLabellimit("");
                        setErrorLabelname("");
                        setErrorLabelprice("");
                        setErrorLabelstart("");
                        setErrorLabelAvailableDate("");
                        setErrorLabeltnc("");
                        setErrorLabelvalue("");
                      }}
                    >
                      <p className="view">Cancel</p>
                    </Link>
                    <Button
                      variant="primary"
                      className="green-btn mt-3"
                      onClick={(e) => handleSubmit(e, "save")}
                    >
                      Save
                    </Button>
                  </div>
                </>
              )}
            </Row>
          </div>
        </div>
      </div>
      <Modals
        className="Modal_Popup"
        show={modalShow}
        onHide={() => setModalShow(false)}
        images={SuccessImage}
        description={
          <>
            Are you sure you want to clone this voucher? Click "Yes" to finish
            creating, but remember, once created you cannot delete the voucher
            but can always disable it whenever you want. This will not affect
            the customers who might have already purchased the voucher, they can
            still redeem it.
          </>
        }
        firstbutton="No"
        secondbutton="Yes"
        saveButtonfuc={handleCreate}
        Apidata={dataApihandler}
      />
      <ProductModal
        className="Modal_Popup"
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        flag="Voucher"
        product_name={dat.voucher_name}
        product_image={cropImgBanner}
        availableDat={availableDate}
        endDat={endDate}
        product_value={parseFloat(dat.voucher_value)}
        product_price={parseFloat(dat.voucher_price)}
        description={description}
        tnc={checkedItems}
      />
      <PrivacyTermsConditions />
    </>
  );
};

export default EditVoucher;
